<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="practica" titulo="Práctica / Coordinación académica"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 79vh;">

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>Nombre</th>
                            <th>Nivel</th>
                            <th>PV</th>
                            <th>CR</th>
                            <th>IB</th>
                            <th>IA</th>
                            <th>Carrera / Plan de estudios</th>
                            <!-- <th>Categoría</th>
                            <th>Materia anterior</th>
                            <th>Clave</th> -->
                            <!-- <th>HD</th> -->
                            <th>Materias que afecta</th>
                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <td style="vertical-align: middle;">{{ 1 + i }}</td>
                            <td style="vertical-align: middle;">{{ item.nombre }} </td>
                            <td style="vertical-align: middle;">{{item.nivel}}</td>
                            <td title="Valor en %" style="vertical-align: middle;">{{item.porcentaje_valor}} %</td>
                            <td style="vertical-align: middle;">
                              <i title="Causa Reprobación" *ngIf="item.causa_reprobacion==1" class="fa fa-check-circle-o is-success"></i>
                            </td>
                            <td style="vertical-align: middle;">
                              <i title="Se imprime en boleta" *ngIf="item.imprimible_boleta==1" class="fa fa-check-circle-o is-success"></i>
                            </td>
                            <td style="vertical-align: middle;">
                              <i title="Se imprime para el alumno" *ngIf="item.imprimible_alumno==1" class="fa fa-check-circle-o is-success"></i>
                            </td>
                            <td style="vertical-align: middle;">{{item.carreras_planes?.carreras?.nombre}} / {{item.carreras_planes?.planes_estudios?.nombre}}</td>
                            <td style="vertical-align: middle;">
                                <span *ngFor="let pm of item.practicas_materias; let p=index"><i class="fa fa-arrow-up"></i> {{pm.materias.nombre}}  </span>
                            </td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="10" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="./assets/128x128.png" alt="Image">
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-medium"> <small>Nombre: {{ item.nombre }}</small></strong>
                                        <strong class="tag is-medium">
                                           Nivel: {{ item.nivel }}
                                        </strong>

                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>
